import * as actionTypes from '../actions/actionTypes';

const initialState  = {
	banners: [],
	calendars: [],
	locations: [],
	pages: [],
	staffList: [],
	textBlocks: []
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_CALENDARS:
		return {
			...state,
			calendars: action.payload
		};
		case actionTypes.SET_LANDINGPAGE_DATA:
		return {
			...state,
			banners: action.payload
		};
		case actionTypes.SET_LOCATIONS:
		return {
			...state,
			locations: action.payload
		};
		case actionTypes.SET_PAGES:
		return {
			...state,
			pages: action.payload
		};
		case actionTypes.SET_STAFF_LIST:
		return {
			...state,
			staffList: action.payload
		};
		case actionTypes.SET_TEXT_BLOCKS:
		return {
			...state,
			textBlocks: action.payload
		};
		default:
		return  state;
	}
};

export default reducer;
